(function () {
    // 注册组件
    SR.component.extend('introduction', introduction);

    function introduction() {
        var hasVisited = SR.util.getStorage('hasVisitedIntroduction');
        if (!SR.state.introduction || !SR.state.isImmersive || hasVisited) {
            return;
        }
        var enterAnimateStyle = 'animated fadeIn';
        var outAnimateStyle = 'animated slideFadeOutDown quick';
        var $pannel = $('<div class="intorduction-pannel">');
        var $content = $('<div class="content">');
        var $closeBtn = $('<div class="close-btn">开始体验</div>');
        var title ='<h2>'+ SR.permissions.title +'</h2>';
        var desc = SR.data.introductionDesc || SR.permissions.title +'是通过语音和文字问答的交互方式，基于优品团队的智能语义分析能力和大数据能力，在用户各类证券垂直场景下，帮助用户快速获得证券领域相关服务的智能（机器人）投顾。';
        var content = title + '<p>' + desc + '</p>';

        $content.append(content);
        $pannel.append($content, $closeBtn);
        SR.dom.$body.append($pannel);
        $pannel.css({
            'margin-top': ($pannel.height() + 80) / 2 * -1
        })
        $closeBtn.on('click', function() {
            hideIntroduction();
        });

        showIntroduction();
        SR.util.updateStorage('hasVisitedIntroduction', 1);

        function showIntroduction() {
            $pannel.show().removeClass(outAnimateStyle).addClass(enterAnimateStyle);
            SR.dom.$mask.fadeIn('fast');
        }

        function hideIntroduction() {
            $pannel.removeClass(enterAnimateStyle).addClass(outAnimateStyle);
            SR.dom.$mask.fadeOut('fast');
        }
    }
}());